import type {MobileAuthedWebviewEntryPointConfig} from '../ConnectElementList';

export const EditPayoutDestinationConfig: MobileAuthedWebviewEntryPointConfig =
  {
    Component: () =>
      import(
        /* webpackChunkName: "EditPayoutDestination" */
        '../../../components/Account/PayoutInformation/PayoutSchedule/EditPayoutDestinationEntryPoint'
      ),
    description: 'Mobile authed webview entry point to edit payout destination',
    friendlyName: 'Mobile entry point: edit payout destination',
    htmlEvents: ['payoutdestinationeditingcomplete'],
    customHtmlElementMethods: {
      // Internal only for closing the authenticated webview in the mobile SDK
      setOnPayoutDestinationEditingComplete: {
        type: 'EventListenerMethod',
        event: 'payoutdestinationeditingcomplete',
        isInternal: true,
        description:
          'Sets the event listener for when the user finishes editing the payout destination',
      },
    },
  };
